const fetchShim = (...args) => {
  if (typeof fetch !== 'function') {
    throw new Error('Fetch API is not available in this environment.');
  }
  return fetch(...args);
};

module.exports = fetchShim;
module.exports.default = fetchShim;
